import { createRoot } from "react-dom/client";
import { initSentry, getSentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!, {
  // Wire up error handlers lazily — they forward to Sentry once loaded
  onUncaughtError: (error, errorInfo) => {
    getSentry()?.then((S) => S.reactErrorHandler()(error, errorInfo));
  },
  onCaughtError: (error, errorInfo) => {
    getSentry()?.then((S) => S.reactErrorHandler()(error, errorInfo));
  },
  onRecoverableError: (error, errorInfo) => {
    getSentry()?.then((S) => S.reactErrorHandler()(error, errorInfo));
  },
}).render(<App />);

// Load Sentry after first paint — keeps 248 KB off the critical path
const idle = window.requestIdleCallback ?? ((cb: () => void) => setTimeout(cb, 1));
idle(() => initSentry(), { timeout: 3000 });
